

  import Vue from 'vue'
  import Component from "vue-class-component";

  import {Prop} from "vue-property-decorator";
  import {namespace} from "vuex-class";
  import {IShortLocker} from "@/model/shortInterfaces";
  import {BoPanel, IOnOffHandlers} from "bonomo/dist";
  import {ILocker2} from "@/model/Locker/lockerInterfaces";
  import LockerSearch from "@/components/locker/widget/LockerSearch.vue";
  import {IErrors} from "@/model/IErrors";
  import LockerChip from "@/components/shared/chips/LockerChip.vue";

  const locker2Module = namespace("locker2Module");

  @Component({
    components: {
      BoPanel,
      LockerChip,
      LockerSearch,
    }
  })
  export default class LTransferDestinations extends Vue {

    @locker2Module.Action('createTransferDestination')
    private createTransferDestination!: ({lockerId, destinationId}: any) => any;
    @locker2Module.Action('errors')
    private setErrors!: (errors: IErrors[]) => any;
    @locker2Module.Getter('errors')
    protected errors!: IErrors[];
    @Prop()
    protected locker!: ILocker2;
    @Prop()
    protected disabled!: boolean;

    protected submitting: boolean = false;
    protected showDialog: boolean = false;
    protected destinationId: number = 0;
    private subscribes: IOnOffHandlers = {};

    get transferDestinationsOrdered(): IShortLocker[] {
      return this.locker.transferDestinations.sort((a, b) => a.name.localeCompare(b.name));
    }

    created() {
      this.subscribes = this.$ons({
        'backend.call.OK.transferDestinationsLoaded': this.onCreateOK,
        'backend.call.KO.transferDestinationsLoaded': this.onCreateKO,
      });
    }
    beforeDestroy() {
      this.$offs(this.subscribes);
    }

    protected lockerFilter(locker: IShortLocker): boolean {
      return (locker.channel_id == this.locker.channel_id) &&
          (locker.status != 'Deleted') &&
          (locker.status != 'Off') &&
          (locker.id != this.locker.id) &&
          !this.locker.transferDestinations.find(each => locker.id == each.id);
    }

    protected onAddClicked() {
      this.showDialog = true;
    }

    protected onLockerSelected(lockerId: number) {
      this.destinationId = lockerId;
      this.setErrors([]);
    }

    protected onCancel() {
      this.showDialog = false;
      // I should clean destinationId but then when I re-open, the locker selector will still have the previous selection but submit disabled, not good
      // this.destinationId = 0;
      this.setErrors([]);
    }

    protected onSubmit() {
      this.submitting = true;
      this.createTransferDestination({lockerId: this.locker.id, destinationId: this.destinationId});
    }

    protected onCreateOK() {
      this.submitting = false;
      this.showDialog = false;
    }

    protected onCreateKO() {
      this.submitting = false;
    }

  }

